import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abf4faca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_3 = ["name", "src"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", {
    class: "modal-iframe-section",
    style: _normalizeStyle({ zIndex: _ctx.isOpenned ? 10001 : 10060 })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['modal-iframe', _ctx.modalOptions?.classNameHeader, _ctx.isOpenned ? 'show' : 'hide'])
    }, [
      _createElementVNode("div", {
        class: "modal-dialog-right",
        style: _normalizeStyle(_ctx.viewportHeight ? `height: ${_ctx.viewportHeight}px` : '')
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.showIframe && _ctx.iFrameUrl != '' && _ctx.iFrameUrl != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("iframe", {
                  name: _ctx.iFrameName,
                  src: _ctx.iFrameUrl
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ], 2)
  ], 4))
}